import styled from 'styled-components';

export const VideoElement = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: transparent;
  display: block;
`;
